/**
 * Trigger a GPX download. Returns 'downloaded' when a[download] works, or
 * 'opened' when we had to fall back to opening the blob in a new tab (old
 * Safari, where a[download] is flaky) — spec 03.
 */
export function exportGpx(fileName: string, gpx: string): 'downloaded' | 'opened' {
  const blob = new Blob([gpx], { type: 'application/gpx+xml' });
  const url = URL.createObjectURL(blob);
  const safe = fileName.replace(/[^\p{L}\p{N}._-]+/gu, '_').slice(0, 80) || 'tur';
  const a = document.createElement('a');

  if ('download' in a) {
    a.href = url;
    a.download = `${safe}.gpx`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 4000);
    return 'downloaded';
  }

  window.open(url, '_blank');
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
  return 'opened';
}
